module.exports = __webpack_public_path__ + "img/whitetrophy.fcdc316b.svg";